import MapLayerWrapper from './MapLayerWrapper';

export default MapLayerWrapper;
